import { CreateWorkspace } from "common/components/CreateWorkspace/index";
import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface CreateWorkspaceModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export default function CreateWorkspaceModal({
  isOpen,
  setIsOpen,
}: CreateWorkspaceModalProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content>
        <CreateWorkspace isDialog />
      </Content>
    </Component>
  );
}
